import brand from '@helpers/brand';
import { Device, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.nav `
  display: block;
`;
const List = styled.ul `
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  border-top: 1px solid ${brand.sage.sageMedium};

  @media ${until(Device.DesktopSmall)} {
    display: none;
  }
`;
export default {
    Container,
    List,
};
